
<script>
import Chart from 'chart.js'

export default {
  name: 'QuizResponseChart',
  props: {
    'chart': Object,
    'name': String
  },
  components: {
  },
  computed: {

  },
  
  data() {
    
    return {
    }
  },
  mounted(){
    let ctx = document.getElementById(this.name).getContext('2d')
    // let ctx1 = document.getElementById('canvas1').getContext('2d')

    new Chart(ctx, this.chart)
    // new Chart(ctx1, this.countsChart)
  },
}
</script>

<template>
<div class="card mb-4">
  <div class="card-body">
    <template >
        <div id="container" style="width: 100%">
          <canvas :id="name"></canvas>
        </div>
      </template>
  </div>
</div>
</template>


<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/QuizResponseChart.vue